/* eslint-disable no-useless-escape */
const ua = window.navigator.userAgent;
const browsersList = [
  {
    reg: /VivoBrowser\/([\d\.]+)/,
    checkName: 'isVivo',
    name: 'Vivo',
  },
  {
    reg: /OppoBrowser\/([\d\.]+)/,
    checkName: 'isOppo',
    name: 'Oppo',
  },
  {
    reg: /MiuiBrowser\/([\d\.]+)/,
    checkName: 'isXiaomi',
    name: 'Miui',
  },
  {
    reg: /HUAWEI[_\s].*\sRelease\/([0-9\.]+)\sBrowser\//,
    checkName: 'isHuawei',
    name: 'Huawei',
  },
  {
    reg: /SamsungBrowser\/([\d\.]+)/,
    checkName: 'isSamsung',
    name: 'Samsung',
  },
  {
    reg: /SAMSUNG.*\sRelease\/([0-9\.]+)\sBrowser\//,
    checkName: 'isSamsung',
    name: 'Samsung',
  },
  {
    reg: /SogouMobileBrowser\/([\d\.]+)/,
    checkName: 'isSogouMobile',
    name: 'Sogou',
  },
  {
    reg: /MxBrowser\/([\d\.]+)/,
    checkName: 'isMxBrowser',
    name: 'MxBrowser',
  },
  {
    reg: /(?:UCWEB|UCBrowser\/)([\d\.]+)/,
    checkName: 'isUC',
    name: 'UC',
  },
  {
    reg: /MQQBrowser\/([\d\.]+)/,
    checkName: 'isQQ',
    name: 'QQBrowser',
  },
  {
    reg: /baidubrowser\/([\d\.]+)/,
    checkName: 'isBaidu',
    name: 'BaiduBrowser',
  },
  {
    reg: /LieBaoFast\/([\d\.]+)/,
    checkName: 'isLieBaoFast',
    name: 'LieBaoFast',
  },
  {
    reg: /(?:Firefox|FxiOS)\/([\d\.]+)/,
    checkName: 'isFirefox',
    name: 'Firefox',
  },
];
let browser = null;

// browser
browsersList.some(({ reg, name, checkName }) => {
  const match = ua.match(reg);
  if (match) {
    browser = {
      name,
      [checkName]: true,
      version: match[1],
    };
    return true;
  }
  return false;
});

// ie bowser
if (!browser) {
  const match = ua.match(/MSIE\s([\d\.]+)/);
  if (match) {
    browser = {
      version: match[1],
    };
    if (ua.match(/IEMobile/)) {
      browser.name = 'IEMobile';
      browser.isIEMobile = true;
    } else {
      browser.name = 'IE';
      browser.isIE = true;
    }
  }
}

// chrome
if (!browser) {
  const match = ua.match(/(?:Chrome|CriOS)\/([\d\.]+)/);
  if (match) {
    browser = {
      name: 'Chrome',
      isChrome: true,
      version: match[1],
    };
  }
}

// chrome webkit
if (ua.match(/Version\/[\d+\.]+\s*Chrome/)) {
  browser.name = 'ChromeWebview';
  browser.isWebview = true;
}

// if (ua.match(/Mozilla\/([0-9\.]+)\s.*(HUAWEI|Huawei).*\sAppleWebKit\/([0-9\.]+)\s.*\sVersion\/([0-9\.]+)\sMobile\sSafari\/([0-9\.]+)/)) {
//   browser = {
//     name: 'HuaweiWebkit',
//     isHuawei: true,
//     version: '0.0.0',
//   };
// }

// other browser
if (!browser) {
  browser = {
    name: 'unknown',
    version: '0.0.0',
  };
}

export default browser;

export const otherBrowser = (() => {
  const isWX = (/micromessenger/i).test(ua);
  const isAlipay = (/AlipayClient/i).test(ua);
  const isQQBrowser = ua.match(/tencenttraveler/i) != null || ua.match(/qqbrowse/i) != null || ua.match(/qq/i) != null;
  return {
    isWX,
    isAlipay,
    isQQBrowser,
  };
})();



// WEBPACK FOOTER //
// ./src/lib/call-app/browser.js